import type { Field } from './types'

type BulkEditSubmissionEntry = {
  update?: boolean
  value?: unknown
  values?: unknown[]
  append?: boolean
}

export const buildBulkEditContent = (
  fields: Record<string, Field>,
  submission: Record<string, BulkEditSubmissionEntry> | null | undefined,
) => {
  if (!submission) return null
  const entries: string[] = []

  for (const [fieldName, entry] of Object.entries(submission)) {
    if (!entry || entry.update === false) continue
    const label = fields[fieldName]?.label ?? fieldName
    const valueText = Array.isArray(entry.values)
      ? formatBulkValue(entry.values)
      : formatBulkValue(entry.value)

    if (valueText) {
      entries.push(`${label}: ${valueText}`)
    }
  }

  return entries.length ? entries.join(' | ') : null
}

const formatBulkValue = (value: unknown): string | null => {
  if (value === null || value === undefined) return null
  if (typeof value === 'boolean') return value ? 'true' : null
  if (typeof value === 'number')
    return Number.isFinite(value) ? `${value}` : null
  if (typeof value === 'string') {
    const trimmed = value.trim()
    return trimmed.length ? trimmed : null
  }
  if (Array.isArray(value)) {
    const items = value
      .map((item) => formatBulkValue(item))
      .filter((item): item is string => Boolean(item))
    return items.length ? items.join(', ') : null
  }
  if (typeof value === 'object') {
    const record = value as Record<string, unknown>
    const labelKeys = ['label', 'description', 'name', 'valueCode', 'code']
    for (const key of labelKeys) {
      const labelLike = record[key]
      if (typeof labelLike === 'string') {
        const trimmed = labelLike.trim()
        return trimmed.length ? trimmed : null
      }
    }
  }
  return null
}
